import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { assertCapabilityNotInQuery } from "@wayfind/core";
import { App } from "./App";
import { Boundary } from "./components/Boundary";
import "./styles.css";

// A capability in a query string is a capability in a CDN log. This runs
// in production too: it costs one regex and it is the only thing standing
// between a refactor and a tracking key leaving the device.
assertCapabilityNotInQuery(location.href);

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root.");

createRoot(root).render(
  <StrictMode>
    {/*
      Outside <App />, so a throw during the app's own mount is caught
      too — a boundary inside the thing that might fail to mount is not a
      boundary. See components/Boundary for why a blank page is the worst
      outcome this screen has.
    */}
    <Boundary>
      <App />
    </Boundary>
  </StrictMode>
);
